/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTranslationDto } from '../../models/create-translation-dto';
import { Translation } from '../../models/translation';

export interface TranslationsControllerCreate$Params {
  
    /**
     * The translation data to create a new translation
     */
    body: CreateTranslationDto
}

export function translationsControllerCreate(http: HttpClient, rootUrl: string, params: TranslationsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Translation>> {
  const rb = new RequestBuilder(rootUrl, translationsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Translation>;
    })
  );
}

translationsControllerCreate.PATH = '/translations';
